import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PropTypes from "prop-types";

const Index = (props) => {
  const { children } = props;
  return (
    <div className="app">
      <Header />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        style={{ zIndex: 1999 }}
      />
      <div className="app-body">
        <Sidebar {...props} />
        <main className="main">
          <Breadcrumb />
          <div className="container-fluid">{children}</div>
        </main>
      </div>
    </div>
  );
};

Index.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Index;



// WEBPACK FOOTER //
// ./client/react/Admin/containers/Navigation/index.js